import { formatDuration, intervalToDuration } from 'date-fns';

export const getFormattedDurationString = (
  durationInSeconds: string | number,
  nullOverride = '-',
) => {
  const parsedSeconds =
    typeof durationInSeconds === 'number' ? durationInSeconds : parseInt(durationInSeconds, 10);
  const validDuration = !Number.isNaN(parsedSeconds);
  if (!validDuration) {
    return nullOverride;
  }
  //   const duration = { seconds: validDuration ? parsedSeconds : 0 };
  const duration = intervalToDuration({ start: 0, end: parsedSeconds * 1000 });
  return formatDuration(duration)
    .replace('years', 'y')
    .replace('months', 'mo')
    .replace('weeks', 'w')
    .replace('days', 'd')
    .replace('hours', 'h')
    .replace('minutes', 'm')
    .replace('seconds', 's');
};
